"use client";

import { useState, useEffect } from "react";
import { useQuestionnaireStore } from "@/store/questionnaire";
import { AccountCard } from "@/components/my-account/AccountCard";

interface QuestionnaireCardRendererProps {
  questionnaire: any;
}

export default function QuestionnaireCardRenderer({ questionnaire }: QuestionnaireCardRendererProps) {
  const { hasAnsweredQuestionnaire } = useQuestionnaireStore();
  const [isClient, setIsClient] = useState(false);
  
  // Fix hydration issue by ensuring client-side rendering matches server-side
  useEffect(() => {
    setIsClient(true);
  }, []);

  // Business logic: Check if user has answered this questionnaire and if it's only fillable once
  // Only check client-side state after hydration to prevent mismatch
  const hasAnswered = isClient ? hasAnsweredQuestionnaire(questionnaire.id) : false;
  const isFillableOnce = questionnaire.attributes.isFillableOnce === true;
  const shouldDisable = hasAnswered && isFillableOnce;

  // If questionnaire is already answered and only fillable once, show "already completed" state
  if (shouldDisable) {
    return (
      <AccountCard
        theme="dark"
        title={questionnaire.attributes.questionnaireCardTitle || "VRAGENLIJST"}
        description={["U heeft deze vragenlijst al ingevuld."]}
      />
    );
  }

  // Otherwise show the normal actionable questionnaire card
  return (
    <AccountCard
      theme="dark"
      title={questionnaire.attributes.questionnaireCardTitle || "VRAGENLIJST"}
      description={[questionnaire.attributes.subtitle]}
      buttonText="BEANTWOORDEN"
      href={`/vragenlijst/${questionnaire.attributes.slug}`}
    />
  );
}